import { createReducer } from 'redux-starter-kit';

import { ProjectsReducerType } from './projects.types';
import {
  SET_PROJECTS,
  CLEAR_PROJECTS,
  SET_PROJECT,
  CLEAR_PROJECT,
  TOGGLE_REMINDER,
} from './projects.actions';

export const initialState: ProjectsReducerType = {
  list: {
    count: -1,
    next: null,
    previous: null,
    results: [],
  },
  selected: {
    json: {},
    status: {
      value: -1,
      display: '',
    },
    name: '',
    product_slug: '',
    product_name: '',
    id: -1,
    aggregates: {},
    package: {
      next_payment_date: null,
      next_payment_price: null,
      package_price: null,
      promo_finish_date: null,
    },
    is_subscribable: false,
    subscription: null,
    send_reminders: null,
  },
};

export default createReducer(initialState, {
  [SET_PROJECTS]: (state, action) => {
    state.list = action.payload;
  },
  [CLEAR_PROJECTS]: (state) => {
    state.list = initialState.list;
  },
  [SET_PROJECT]: (state, action) => {
    state.selected = action.payload;
  },
  [CLEAR_PROJECT]: (state) => {
    state.selected = initialState.selected;
  },
  [TOGGLE_REMINDER]: (state) => {
    state.selected = {
      ...state.selected,
      send_reminders: !state.selected.send_reminders,
    };
  },
});
